var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.111,
    height: 21.111,
    viewBox: "0 0 21.111 21.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus_9.55.16_AM",
    "data-name": "plus 9.55.16 AM",
    transform: "translate(21.111) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4339",
    "data-name": "Rectangle 4339",
    width: 21.111,
    height: 21.111,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 14.778,
    transform: "translate(3.167 10.556)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    y2: 14.778,
    transform: "translate(10.556 3.167)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEvent);
export default __webpack_public_path__ + "static/media/addEvent.d6567d8198e9ff58aad752160b77dcd5.svg";
export { ForwardRef as ReactComponent };